import * as React from 'react';
import { Helmet } from 'react-helmet';

const FlatfyDomainsLinker = () => (
  <Helmet>
    <link rel="alternate" href="https://flatfy.com/" hrefLang="x-default" />
    <link rel="alternate" hrefLang="hu-HU" href="https://hu.flatfy.com" />
    <link rel="alternate" hrefLang="pl-PL" href="https://flatfy.pl/" />
    <link rel="alternate" hrefLang="ro-RO" href="https://flatfy.ro/" />
    <link rel="alternate" hrefLang="cs-CZ" href="https://flatfy.cz/" />
    <link rel="alternate" hrefLang="ru-KZ" href="https://flatfy.kz/" />
    <link rel="alternate" hrefLang="ru-RU" href="https://flatfy.ru/" />
    <link rel="alternate" hrefLang="ru-BY" href="https://flatfy.by/" />
    <link rel="alternate" hrefLang="az-AZ" href="https://flatfy.az/" />
    <link rel="alternate" hrefLang="tr-TR" href="https://tr.flatfy.com/" />
    <link rel="alternate" hrefLang="bg-BG" href="https://bg.flatfy.com/" />
    <link rel="alternate" hrefLang="hi-IN" href="https://flatfy.in" />
    <link rel="alternate" hrefLang="vi-VN" href="https://flatfy.vn" />
    <link rel="alternate" hrefLang="en-NG" href="https://flatfy.ng/" />
    <link rel="alternate" hrefLang="th-TH" href="https://flatfy.in.th" />
    <link rel="alternate" hrefLang="id-ID" href="https://flatfy.id/" />
    <link rel="alternate" hrefLang="en-MY" href="https://flatfy.my" />
    <link rel="alternate" hrefLang="en-ZA" href="https://flatfy.co.za/" />
    <link rel="alternate" hrefLang="en-PH" href="https://flatfy.ph/" />
    <link rel="alternate" hrefLang="ka-GE" href="https://flatfy.ge/" />
    <link rel="alternate" hrefLang="es-CL" href="https://flatfy.cl" />
    <link rel="alternate" hrefLang="en-AE" href="https://flatfy.ae/" />
    <link rel="alternate" hrefLang="ar-AE" href="https://flatfy.ae/ar-AE/" />
    <link rel="alternate" hrefLang="ro-MD" href="https://flatfy.md/" />
    <link rel="alternate" hrefLang="lt-LT" href="https://flatfy.lt/" />
    <link rel="alternate" hrefLang="lv-LV" href="https://flatfy.lv/" />
    <link rel="alternate" hrefLang="et-EE" href="https://flatfy.ee/" />
    <link rel="alternate" hrefLang="el-GR" href="https://flatfy.gr/" />
    <link rel="alternate" hrefLang="sl-SI" href="https://flatfy.si/" />
    <link rel="alternate" hrefLang="ru-UZ" href="https://flatfy.uz/" />
    <link rel="alternate" hrefLang="ru-KG" href="https://flatfy.kg/" />
    <link rel="alternate" hrefLang="ru-UA" href="https://flatfy.ua/" />
  </Helmet>
);

export default FlatfyDomainsLinker;
